import React from 'react';
import { useNavigate } from 'react-router-dom';

const SplashPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="page bg-[#3C4959] justify-center items-center px-5 py-8 gap-6">
      {/* Main content card */}
      <div className="bg-white border border-black/25 rounded-[48px] py-8 px-6 flex flex-col items-center w-full max-w-[320px]">
        {/* Logo - ¬∧∨ with rounded background */}
        <div className="bg-[#8EA6C0] rounded-full px-5 py-2 mb-5">
          <span className="font-serif text-[22px] font-bold text-[#25384D] tracking-wide">
            ¬∧∨
          </span>
        </div>

        {/* Title box */}
        <div className="bg-[#8EA6C0] rounded-[20px] py-6 px-5 w-full mb-5">
          <h1 className="font-serif text-[22px] font-bold text-[#25384D] text-center leading-[1.3] m-0">
            Master of Practical
            <br />
            Mandarin
          </h1>
        </div>

        {/* Start button */}
        <button
          className="bg-[#8EA6C0] text-[#25384D] py-3 px-10 rounded-full font-serif text-lg font-bold border-none cursor-pointer transition-all active:scale-[0.97] active:opacity-90"
          onClick={() => navigate('/login')}
        >
          Start
        </button>
      </div>

      {/* Footer card */}
      <div className="bg-white border border-black/25 rounded-[48px] py-5 px-6 w-full max-w-[280px]">
        <p className="font-serif text-[13px] font-bold text-[#25384D] text-center leading-[1.6] m-0">
          Copyright © [2025] [廖梓宏]
          <br />
          All rights reserved.
        </p>
        <p className="font-serif text-[13px] font-bold text-[#25384D] text-center leading-[1.6] m-0 mt-3">
          [ Acknowledgments ]
          <br />
          Font Awesome (CC BY 4.0)
          <br />
          Material Symbols
          <br />
          Google Fonts
        </p>
      </div>
    </div>
  );
};

export default SplashPage;
